// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  padding: 10px 10px 0;
  margin: 0 auto;
  background: white;
}

::ng-deep .dx-scheduler-group-header-content {
  padding-left: 0px !important;
  padding: 5px 0px !important;
}
::ng-deep .dx-scheduler-group-header-content div {
  text-align: center;
  white-space: normal !important;
  line-height: 1.2;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.actions {
  width: 250px;
}
.actions .dx-calendar {
  width: 250px;
  height: 250px;
}
.actions .options {
  height: calc(100vh - 415px);
  display: flex;
  flex-direction: column;
}
.actions .selectList {
  width: 250px;
  height: calc(50% - 4px);
  /*  &:first-child {
      height: calc(50% - 11px);
  } 
   &:not(:first-child) {
      height: 50%;
  } */
}
.actions .selectList dx-list {
  height: calc(100% - 16px);
}
.actions .marg-padding-7 {
  margin-bottom: 7px;
  padding-bottom: 7px;
  border-bottom: 1px solid #ebebeb;
}

@media only screen and (max-width: 650px) {
  .calendar-container .row {
    height: 85vh;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .calendar-container .row .actions {
    order: 1;
    width: 95vw;
  }
  .calendar-container .row .actions dx-calendar {
    display: none;
  }
  .calendar-container .row .actions .options .selectList {
    display: inline-block !important;
    width: calc(50vw - 20px);
    height: calc(15vh - 10px);
    border: none;
  }
  .calendar-container .row .actions .options .selectList label {
    font-size: 14px;
    font-weight: 500;
  }
  .calendar-container .row .actions .selectList dx-list {
    height: 75px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/view/scheduler/calendar/calendar.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,4BAAA;EACA,2BAAA;AACJ;AACI;EACI,kBAAA;EACA,8BAAA;EACA,gBAAA;AACR;;AAIA;EACI,aAAA;EACA,eAAA;AADJ;;AAKA;EACI,YAAA;AAFJ;AAII;EACI,YAAA;EACA,aAAA;AAFR;AAKI;EAEI,2BAAA;EACA,aAAA;EACA,sBAAA;AAJR;AAOI;EACI,YAAA;EACA,uBAAA;EAEA;;;;;KAAA;AADR;AAQQ;EAEI,yBAAA;AAPZ;AAWI;EACI,kBAAA;EACA,mBAAA;EACA,gCAAA;AATR;;AAaA;EAEQ;IAEI,YAAA;IACA,aAAA;IACA,eAAA;IACA,sBAAA;EAZV;EAcU;IACI,QAAA;IACA,WAAA;EAZd;EAcc;IACI,aAAA;EAZlB;EAgBkB;IACI,gCAAA;IACA,wBAAA;IACA,yBAAA;IACA,YAAA;EAdtB;EAgBsB;IACI,eAAA;IACA,gBAAA;EAd1B;EAmBc;IACI,YAAA;EAjBlB;AACF","sourcesContent":[".calendar-container {\n    padding: 10px 10px 0;\n    margin: 0 auto;\n    background: white;\n}\n\n::ng-deep .dx-scheduler-group-header-content {\n    padding-left: 0px !important;\n    padding: 5px 0px !important;\n\n    div {\n        text-align: center;\n        white-space: normal !important;\n        line-height: 1.2;\n    }\n\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n\n.actions {\n    width: 250px;\n\n    .dx-calendar {\n        width: 250px;\n        height: 250px;\n    }\n\n    .options {\n        // 413px header + footer + calendar + padding & margin & border\n        height: calc(100vh - 415px);\n        display: flex;\n        flex-direction: column;\n    }\n\n    .selectList {\n        width: 250px;\n        height: calc(50% - 4px);\n        // padding-bottom: 0px !important;\n        /*  &:first-child {\n            height: calc(50% - 11px);\n        } \n         &:not(:first-child) {\n            height: 50%;\n        } */\n\n        dx-list {\n            // 16px label\n            height: calc(100% - 16px);\n        }\n    }\n\n    .marg-padding-7 {\n        margin-bottom: 7px;\n        padding-bottom: 7px;\n        border-bottom: 1px solid #ebebeb;\n    }\n}\n\n@media only screen and (max-width: 650px) {\n    .calendar-container {\n        .row {\n\n            height: 85vh;\n            display: flex;\n            flex-wrap: wrap;\n            flex-direction: column;\n\n            .actions {\n                order: 1;\n                width: 95vw;\n\n                dx-calendar {\n                    display: none;\n                }\n\n                .options {\n                    .selectList {\n                        display: inline-block !important;\n                        width: calc(50vw - 20px);\n                        height: calc(15vh - 10px);\n                        border: none;\n\n                        label {\n                            font-size: 14px;\n                            font-weight: 500;\n                        }\n                    }\n                }\n\n                .selectList dx-list {\n                    height: 75px;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
